module.exports = __webpack_public_path__ + "img/bg-desk.73afb8af.jpg";